import { render, staticRenderFns } from "./ScoringDialogFirstLevelTabComponent.vue?vue&type=template&id=c244be60&scoped=true"
import script from "./ScoringDialogFirstLevelTabComponent.js?vue&type=script&lang=js&external"
export * from "./ScoringDialogFirstLevelTabComponent.js?vue&type=script&lang=js&external"
import style0 from "./ScoringDialogFirstLevelTabComponent.vue?vue&type=style&index=0&id=c244be60&prod&scoped=true&lang=scss"
import style1 from "./ScoringDialogFirstLevelTabComponent.vue?vue&type=style&index=1&id=c244be60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c244be60",
  null
  
)

export default component.exports